import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX, FILES_API_PREFIX } from '../utils/constants';
import {
  BodyPutFileApiV1FileStorageFilePost,
  DeleteFilesRequest
} from '../types/apiGeneratedTypes';

export const putFile = async (
  body: BodyPutFileApiV1FileStorageFilePost & { file_type?: string }
): Promise<any> => {
  const formData = new FormData();
  formData.append('file', body.file);
  
  if (body.file_type) {
    formData.append('file_type', body.file_type);
  }

  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${FILES_API_PREFIX}file`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
export const putStatic = async (
  body: BodyPutFileApiV1FileStorageFilePost
): Promise<any> => {
  const formData = new FormData();
  formData.append('file', body.file);

  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${FILES_API_PREFIX}static`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
export const putPhoto = async (
  body: BodyPutFileApiV1FileStorageFilePost
): Promise<any> => {
  const formData = new FormData();
  formData.append('file', body.file);

  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${FILES_API_PREFIX}photo`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const deleteFile = async (files: DeleteFilesRequest): Promise<any> => {
  try {
    await axiosInstance.delete(`${API_V1_PREFIX}${FILES_API_PREFIX}delete`, {
      data: files
    });
    return true;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const listInuviFiles = async (
  limit: number,
  offset: number
): Promise<any> => {
  try {
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
    });

    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${FILES_API_PREFIX}inuvi/files?${params.toString()}`
    );
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
